import { render, staticRenderFns } from "./CommitteeElections.vue?vue&type=template&id=5a60f6ae"
import script from "./CommitteeElections.vue?vue&type=script&lang=js"
export * from "./CommitteeElections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports